<script>
    import Page from './Page/Page.svelte';
    import {survey} from '../stores';
    import {txt} from '../i18n/i18n';
    import Tabs from '@itslearning/prometheus/assets/Navigation/Tabs/v1/Tabs.svelte';
    import TabPanel from '@itslearning/prometheus/assets/Navigation/Tabs/v1/TabPanel.svelte';
    import AiSurvey from './AISurvey.svelte';
    import EditSurvey from './EditSurvey.svelte';

    const tabs = [ { id: "tabCreateSurvey", target: "#createSurvey", title: txt('Create_survey') }, { id: "tabAI", target: "#createSurveyAI", title: txt('Create_survey_with_AI') } ];
  
</script>

<Page title={txt('Edit_survey')} displayHeading={false}>
    <form on:submit|preventDefault aria-live="polite" id="form-survey" class="proto-form">
        {#if $survey.isCreated || !$survey.aiEnabled}
            <EditSurvey/>
        {:else}
            <Tabs tabs={tabs}>
                <TabPanel id="addSurvey" >
                    <EditSurvey/>
                </TabPanel>
                <TabPanel id="addSurveyAI">
                    <AiSurvey/>
                </TabPanel>
            </Tabs>
        {/if}
    </form>
</Page>